
/**
 * Переключатель вида карточки («Распределение ↔ Динамика», «Тепловая карта ↔ По пунктам»).
 *
 * Когда переключать нечего, вместо него остаётся пустая полоса той же высоты. Это не
 * лишний отступ: карточки стоят парами в одном ряду сетки, и если у соседа переключатель
 * есть, а у этой карточки нет, область графика начинается на разной высоте — заголовки
 * и подписи в ряду «прыгают». Резерв места держит их на одной линии.
 */
const SWITCH_HEIGHT = 'h-7';

const NodeViewSwitch = ({ views = [], value, onChange }) => {
  if (views.length < 2) {
    return <div className={SWITCH_HEIGHT} aria-hidden="true" />;
  }

  return (
    <div className={`flex ${SWITCH_HEIGHT} items-center`}>
      <div className="flex rounded-md border p-0.5">
        {views.map((view) => (
          <button
            key={view.code}
            type="button"
            data-ev="nodes.view.switch"
            data-ev-value={view.code}
            onClick={() => onChange(view.code)}
            className={`rounded px-2 py-0.5 text-xs transition-colors ${
              value === view.code ? 'bg-muted font-medium' : 'text-muted-foreground hover:bg-muted/50'
            }`}
          >
            {view.label}
          </button>
        ))}
      </div>
    </div>
  );
};

export default NodeViewSwitch;
